<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer006">
<h1 class="chpTitle-break" id="_idParaDest-4"><b>Contents</b></h1>
<p class="contentslist"><a href="#/QueenForADay13">Sleepwalking Boy</a></p>
<p class="contentslist"><span href="#/QueenForADay14" title="Link target outside of Sample">The Story of Annie Sullivan</span></p>
<p class="contentslist"><span href="#/QueenForADay15" title="Link target outside of Sample">Yolanda</span></p>
<p class="contentslist"><span href="#/QueenForADay16" title="Link target outside of Sample">Two Mothers</span></p>
<p class="contentslist"><span href="#/QueenForADay17" title="Link target outside of Sample">Queen for a Day</span></p>
<p class="contentslist"><span href="#/QueenForADay18" title="Link target outside of Sample">This Time Next Year</span></p>
<p class="contentslist"><span href="#/QueenForADay19" title="Link target outside of Sample">Route 94</span></p>
<p class="contentslist"><span href="#/QueenForADay20" title="Link target outside of Sample">The Bike Path</span></p>
<p class="contentslist"><span href="#/QueenForADay21" title="Link target outside of Sample">The Boy Who Lived on a Desert Island</span></p>
<p class="contentslist"><span href="#/QueenForADay22" title="Link target outside of Sample">A Sample Boy</span></p>
<p class="contentslist"><span href="#/QueenForADay23" title="Link target outside of Sample">The Red Cart</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// QueenForADay12.vue?76ed2c43